import type { Term, WordpressPage, WordpressPost } from '@benzinga/content-manager';
import type { MetaProps } from '@benzinga/seo';
import type { PageConfig } from '../../_components/page/pageConfig';

export type RouteMetaPayload = {
  metaProps?: MetaProps | null;
  pageTargeting?: PageConfig['pageTargeting'];
  disableFooterDisplayAd?: boolean;
  /** @deprecated Use disableFooterDisplayAd */
  disableStickyFooter?: boolean;
  /** @deprecated Use disableFooterDisplayAd */
  disableRaptiveFooter?: boolean;
  article?: unknown;
  post?: WordpressPage | WordpressPost;
  term?: Term;
  disablePageTracking?: boolean;
};

export const resolveRouteMetaDisableFooterDisplayAd = (payload?: RouteMetaPayload | null): boolean =>
  !!(payload?.disableFooterDisplayAd ?? payload?.disableStickyFooter ?? payload?.disableRaptiveFooter);
